// tslint:disable:ordered-imports
// tslint:disable:no-import-side-effect
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import tinymce from 'tinymce/tinymce';
import 'tinymce/plugins/autoresize/plugin.min';
import 'tinymce/plugins/code/plugin.min';
import 'tinymce/plugins/link/plugin.min';
import 'tinymce/plugins/lists/plugin.min';
import 'tinymce/plugins/paste/plugin.min';
import 'tinymce/plugins/searchreplace/plugin';
import 'tinymce/plugins/table/plugin';
import 'tinymce/plugins/textcolor/plugin';
import 'tinymce/plugins/wordcount/plugin';
import 'tinymce/themes/modern/theme';

export class RichTextEditor {
    editor: any;

    protected _onChange$ = new Subject<string>();
    protected initialContent: string = '';

    /**
     * Returns the current content
     * @return {string}
     */
    get content(): string {
        return this.editor.getContent();
    }

    /**
     * Sets the content, replacing all existing content
     * @param content {string}
     */
    set content(content: string) {

        if (!this.editor) {
            this.initialContent = content;
            return;
        }

        this.editor.setContent(content);
    }

    /**
     * Returns an observable that emits the content of the editor after each
     * key up or change event in the editor
     * @return {Observable<string>}
     */
    get onChange$(): Observable<string> {
        return this._onChange$;
    }

    /**
     * Returns the list of TinyMCE plugins that will be loaded into the editor
     * @return {Array<string>}
     */
    get plugins(): Array<string> {
        return [
            'code',
            'link',
            'lists',
            'paste',
            'searchreplace',
            'table',
            'textcolor',
            'wordcount'
        ];
    }

    /**
     * Returns the toolbar configuration used by the TinyMCE editor
     * @return {string}
     */
    get toolbar(): string {
        return [
            'bold italic underline strikethrough',
            'alignleft aligncenter alignright alignjustify',
            'styleselect',
            'bullist numlist',
            'textcolor',
            'searchreplace',
            'table',
            'undo redo',
            'forecolor backcolor',
            'code'
        ].join(' | ');
    }

    /**
     * Destroys the editor. This should be called from ngOnDestroy
     */
    destroy(): void {
        if (!this.editor) {
            return;
        }
        tinymce.remove(this.editor);
        this.editor.destroy();
    }

    /**
     * Inserts content at the location of the cursor
     * @param content {string}
     */
    insertContent(content: string): void {
        try {
            this.editor.execCommand('mceInsertContent', false, content);
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * Initialises TinyMCE on the element identified by the selector - usually
     * a textarea. If the textarea contains a value, then this value will be
     * used by TinyMCE as the initial value of the editor.
     * @param selector {string}
     */
    init(selector: string): Promise<any> {
        return new Promise<any>(resolve => {
            tinymce.init({
                selector,
                plugins: this.plugins,
                branding: false,
                elementpath: false,
                statusbar: false,
                // skin: false,
                height: 500,
                menubar: false,
                toolbar: this.toolbar,
                skin_url: 'assets/skins/lightgray',
                force_br_newlines: true,
                force_p_newlines: false,
                forced_root_block: 'p',
                browser_spellcheck: true,
                gecko_spellcheck: true,
                setup: editor => {
                    this.editor = editor;
                    this.editor.setContent(this.initialContent);
                    editor.on('keyup', () => {
                        this._onChange$.next(editor.getContent());
                    });
                    editor.on('change', () => {
                        this._onChange$.next(editor.getContent());
                    });
                    resolve(editor);
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/helpers/rich-text-editor.ts